import classNames from 'classnames';
import { useState } from 'react';

import Cover from '@/components/cover';
import { EditorAddImage } from '@/components/icon';
import { RenameType, UserResourceType } from '@/interface/library';
import { CgiErrorCode } from '@/services/cgi';
import { UserResourceDetail } from '@/services/library';
import { useAppDispatch } from '@/store';
import { changeId } from '@/store/modules/library';

import Rename from '../rename';
import { LibraryImageViewer } from '../review/image';
import styles from './index.module.less';

export const NameLength = 10;
interface IProps {
  value: UserResourceDetail;
  type: UserResourceType | undefined;
  index: number;
  url: string;
  resourceName: string;
  checked: boolean;
  urls: string[];
  disabled: boolean;
  handleCheckedChange: (check: boolean) => void;
  updateResource: (value: UserResourceDetail) => void;
  reNameCallback: (info: UserResourceDetail) => void
}
const ImageItem: React.FC<IProps> = (props) => {
  const {
    urls, type, url,
    resourceName, checked, index,
    value, disabled,
    handleCheckedChange,
    reNameCallback,
  } = props;

  const dispatch = useAppDispatch();

  const spliceName = resourceName.slice(0, NameLength);
  const name = resourceName?.length > NameLength ? `${spliceName}...` : spliceName;
  const [visible, setVisible] = useState(false);

  const changeVisible = (vi: boolean) => {
    if (vi) {
      dispatch(changeId({ id: value.resourceId }));
    }
    setVisible(vi);
  };


  const handleStopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const reName = (code: CgiErrorCode, info: {
    name: string, id: string
  }) => {
    if (code === CgiErrorCode.NO_ERROR) {
      reNameCallback({ ...value, resourceName: info.name });
    }
  };

  return (
    <div className={classNames(styles.item, {
      [styles.checked]: checked,
    })}>
      <LibraryImageViewer
        type={type}
        images={urls}
        defaultIndex={index}
        checked={checked}
        onCheckedChange={check => handleCheckedChange(check)}
      >
        <div className={styles.content}>
          <Cover
            width="68"
            height="120"
            src={url}
            innerClassName={styles.coverInner}
            outerClassName={styles.coverInner}
            className={styles.cover}
          ></Cover>
        </div>
      </LibraryImageViewer>
      <div className={styles.fileName} onClick={handleStopPropagation}>
        {
          visible
            ? <Rename
              resourceName={resourceName}
              type={RenameType.TYPE_RENAME_RESOURCE}
              id={value.resourceId || ''}
              visible={visible}
              callBack={reName}
              changeVisible={changeVisible}
            /> : <>
              <EditorAddImage /><span className={styles.name}>{name}</span>
              {
                disabled ? null : <span className={styles.edit}>
                  <Rename
                    resourceName={resourceName}
                    type={RenameType.TYPE_RENAME_RESOURCE}
                    id={value.resourceId || ''}
                    visible={visible}
                    changeVisible={changeVisible}
                  />
                </span>
              }
            </>
        }
      </div>
    </div>
  );
};

export default ImageItem;
